<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 632.000000 632.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,632.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M2985 5568 c-77 -22 -662 -185 -1299 -363 -995 -278 -1163 -328
      -1185 -350 l-26 -25 -5 -1188 -5 -1187 -83 -109 c-344 -454 -457 -857 -309
      -1108 14 -24 50 -66 79 -95 327 -308 1169 -213 2273 258 308 131 879 424 1167
      599 72 44 134 80 137 79 3 0 46 -65 95 -145 49 -80 92 -147 96 -149 10 -6 870
      1031 870 1049 0 9 -6 16 -13 16 -20 0 -1306 -316 -1313 -322 -3 -4 17 -42 45
      -87 28 -44 51 -84 51 -87 0 -4 18 -35 40 -70 l40 -63 -44 -29 c-61 -41 -275
      -165 -431 -249 -892 -482 -1717 -774 -2291 -812 -364 -23 -584 47 -672 213
      -24 46 -27 61 -27 156 0 82 5 121 23 180 35 111 122 287 199 403 l68 102 5
      -357 5 -358 26 -25 c21 -21 82 -42 324 -110 l298 -83 114 24 c261 54 319 80
      236 104 -21 6 -204 57 -408 114 l-370 103 -3 1522 c-2 1447 -1 1522 15 1517
      10 -3 518 -145 1128 -315 611 -170 1133 -315 1160 -324 l50 -14 3 -997 2 -998
      88 47 c133 72 361 205 367 215 2 4 -41 80 -97 169 -55 89 -99 164 -96 166 4 4
      1416 352 1741 429 24 6 21 -3 -12 -39 -43 -46 -1088 -1301 -1103 -1325 -7 -11
      -17 -20 -23 -20 -5 0 -57 74 -114 165 -64 102 -108 162 -115 158 -6 -4 -49
      -30 -96 -59 -97 -59 -287 -165 -437 -244 l-103 -54 0 -322 c0 -176 -2 -323 -5
      -326 -3 -2 -204 51 -448 119 -387 109 -446 123 -472 113 -16 -6 -90 -31 -162
      -57 -125 -43 -146 -54 -124 -67 7 -5 1040 -295 1243 -349 l77 -21 188 53 c103
      29 688 192 1298 362 611 170 1124 316 1141 325 18 9 37 27 43 40 8 18 11 483
      11 1685 0 1778 2 1704 -47 1724 -10 4 -191 56 -402 115 -211 59 -379 110 -373
      114 6 3 77 18 159 33 129 23 176 27 368 27 181 1 232 -2 285 -17 155 -42 261
      -124 296 -229 34 -104 12 -262 -61 -432 -34 -80 -35 -84 -35 -218 0 -79 4
      -139 10 -143 12 -8 69 81 137 215 114 225 156 436 118 584 -51 193 -187 319
      -410 376 -243 62 -629 36 -1046 -71 l-156 -39 -554 154 c-305 85 -644 180
      -753 210 -110 31 -211 56 -225 55 -14 0 -89 -19 -166 -41z m548 -282 c204 -58
      689 -193 1077 -301 388 -108 706 -198 708 -200 4 -4 43 7 -553 -159 -601 -167
      -1197 -333 -1438 -401 l-168 -48 -127 35 c-908 253 -1974 551 -2002 560 -31
      10 -32 12 -15 19 11 5 434 124 940 265 506 141 981 273 1055 294 74 21 138 39
      143 39 4 1 175 -46 380 -103z"/>
    </g>
  </svg>
</template>

<script setup>
</script>